import { render, staticRenderFns } from "./editShopVipLevel.vue?vue&type=template&id=f388e662"
import script from "./editShopVipLevel.vue?vue&type=script&lang=js"
export * from "./editShopVipLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports